module.exports = "/_next/static/images/favicon-32x32-ec2c76c8b1104a54d07e28122a83dee9.png";